var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fireworks-wrapper"},[_c('div',{staticClass:"pyro"},[_c('div',{staticClass:"before"}),_c('div',{staticClass:"after"})])])
}]

export { render, staticRenderFns }